import React from "react";
import "./iconButton.css";

interface IconButtonProps {
  icon: string;
  onClick: () => void;
  alt: string;
  dataTestId?: string;
  className?: string;
}

export function IconButton({ icon, onClick, alt, dataTestId, className }: IconButtonProps) {
  return (
    <button
      className={`icon-button ${icon} ${className}`}
      aria-label={alt}
      onClick={onClick}
      data-testid={dataTestId}
    ></button>
  );
}
